if (!customElements.get('free-shipping')) {
  class FreeShipping extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      let total = parseInt(this.dataset.cartTotal, 10);
      let freeShippingMinimum = Math.round(
        parseInt(this.dataset.freeShippingMinimum, 10) * (Shopify.currency.rate || 1)
      );
      let freeProductMinimum = Math.round(
        parseInt(this.dataset.freeProductMinimum, 10) * (Shopify.currency.rate || 1)
      );
      let percentage = 1;

      this.messages = {
        spendMoreForFreeShipping: this.querySelector('[data-type="spend-more-for-free-shipping"]'),
        freeShippingApplied: this.querySelector('[data-type="free-shipping-applied"]'),
        spendMoreForFreeProduct: this.querySelector('[data-type="spend-more-for-free-product"]'),
        freeProductApplied: this.querySelector('[data-type="free-product-applied"]'),
      };

      // Hide all messages first
      for (let key in this.messages) {
        if (this.messages[key]) {
          this.messages[key].style.display = 'none';
        }
      }

      let format = window.theme.settings.money_with_currency_format || "${{amount}}";

      if (total < freeShippingMinimum) {
        // Scenario 1: Need to spend more for free shipping
        let remaining = freeShippingMinimum - total;
        if (this.messages.spendMoreForFreeShipping) {
          this.messages.spendMoreForFreeShipping.innerHTML = `Spend ${formatMoney(
            remaining,
            format
          )} more to get <div data-nosnippet>free shipping</div>`;
          this.messages.spendMoreForFreeShipping.style.display = 'block';
        }
        percentage = total / freeProductMinimum;
      } else if (total >= freeShippingMinimum && total < freeProductMinimum) {
        // Scenario 2: Free shipping applied, need to spend more for free product
        if (this.messages.freeShippingApplied) {
          this.messages.freeShippingApplied.style.display = 'block';
        }
        let remaining = freeProductMinimum - total;
        if (this.messages.spendMoreForFreeProduct) {
          this.messages.spendMoreForFreeProduct.innerHTML = `Spend ${formatMoney(
            remaining,
            format
          )} more to get a free gift`;
          this.messages.spendMoreForFreeProduct.style.display = 'block';
        }
        percentage = total / freeProductMinimum;
      } else {
        // Scenario 3: Both free shipping and free product applied
        if (this.messages.freeShippingApplied) {
          this.messages.freeShippingApplied.style.display = 'block';
        }
        if (this.messages.freeProductApplied) {
          this.messages.freeProductApplied.style.display = 'block';
        }
        percentage = 1;
      }

      // Update the progress bar
      this.style.setProperty('--percentage', percentage);
    }
  }
  customElements.define('free-shipping', FreeShipping);
}
